import bookCalendar from "./calendar/calendar";
import getRooms from "./functions/get-rooms";
import getGames from "./functions/get-games";
import getArena from "./functions/get-arena";
import timeSlot from "./functions/get-time-slot";
import addBooking from "./functions/add-booking";

const form = document.querySelector('#admin-form-booking') as HTMLFormElement;

if(form !== null){

    // Calendar
    const book_calendar = bookCalendar();

    // Get rooms
    const modGetRooms = new getRooms();
    const rooms = modGetRooms.get('#admin_field_room');

    // Get games
    const modGetGames = new getGames();
    const games = modGetGames.get('#admin_field_game');

    // Get arena
    const modGetArena = new getArena();
    const arenaID = modGetArena.get('#admin_field_arena_id', '#admin_field_room');

    // Time slot
    const modTimeSlot = new timeSlot();
    const time_slot = modTimeSlot.get(
        book_calendar,
        '#admin_field_room',
        '#admin_field_game',
        '#admin_field_time_slot'
    );

    // Add booking
    const modAddBooking = new addBooking(
        form,
        rooms,
        games,
        arenaID,
        time_slot,
        '#admin_btn_booking_submit'
    );

}